import { Text } from '@billy/design-system'
import React, { ReactElement, useRef } from 'react'

import * as Styled from './styles'

export type ItemOptions = {
  truncateValue?: boolean
  itemPerRow?: boolean
  containerWidth: number
}

const renderItems = (items: GridListItem[], options: ItemOptions) => {
  const { containerWidth, itemPerRow, truncateValue } = options

  return items.map((item) => {
    const { id, text, value } = item

    return (
      <Styled.GridItem key={id} containerWidth={containerWidth} itemPerRow={itemPerRow}>
        <Text colorVariant="secondary">{text}</Text>
        <Text weight="medium" truncate={truncateValue} title={truncateValue ? value : ''}>
          {value}
        </Text>
      </Styled.GridItem>
    )
  })
}

export type GridListItem<T = string> = {
  id: T
  text: string
  value: string
}

export type GridListProps<T = string> = {
  className?: string
  itemPerRow?: boolean
  items: GridListItem<T>[]
  truncateValue?: boolean
}

export const GridList = <T extends string>({
  items,
  truncateValue = true,
  itemPerRow,
  className,
}: GridListProps<T>): ReactElement => {
  const containerRef = useRef<HTMLUListElement>(null)
  const options: ItemOptions = {
    containerWidth: containerRef?.current?.clientWidth || 0,
    itemPerRow,
    truncateValue,
  }

  return (
    <Styled.GridListWrapper ref={containerRef} className={className}>
      {renderItems(items, options)}
    </Styled.GridListWrapper>
  )
}
